import React, { useContext, useMemo } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { VisibilityOutlined } from '@mui/icons-material';
import { convertirLetraMayus } from '../../../helpers/convertirLetraMayus';
import { AuthContext } from '../../../contexts/AuthContext';
import { encontrarModulo } from '../../../helpers/encontrarModulo';
import { useModalStore } from '../../../store/useModalStore';
import { ViewInactiveForm } from './ViewInactiveForm';

export const Actions = ({ data }) => {

    const { usuario: { rol: { nombre: rol }, permisos } } = useContext(AuthContext);
    const { openModal } = useModalStore();

    const actions = useMemo(() => {
        return encontrarModulo(permisos, 'inactivos')?.actions?.filter(a => a?.name !== 'crear')?.map(a => (rol?.includes('admin') || a?.active) ? a : null);
    }, []);

    const buttons = [
        { icon: <VisibilityOutlined color='action' fontSize='small' />, action: () => openModal(<ViewInactiveForm data={ data } />) }
    ];

    return (
        <>
            { actions?.map((a, i) => a?.name?.includes('ver') && (
                <Tooltip key={ a?.name } title={ convertirLetraMayus(a?.name) }>
                    <IconButton aria-label="read" onClick={ buttons[i]?.action }>
                        { buttons[i]?.icon }
                    </IconButton>
                </Tooltip>
            ))}
        </>
    );
}